import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { OrganizationProfile, UpdateOrganizationProfile } from '../../domain/models/organization-profile.model';
import { IOrganizationProfileRepository } from '../../domain/repositories/organization-profile.repository';
import { OrganizationProfileRemoteDatasource } from '../datasources/remote/organization-profile.remote-datasource';
import { OrganizationProfileMapper } from '../mappers/organization-profile.mapper';

@Injectable()
export class OrganizationProfileRepositoryImpl implements IOrganizationProfileRepository {
  private readonly datasource = inject(OrganizationProfileRemoteDatasource);
  private readonly mapper = inject(OrganizationProfileMapper);

  public get(organizationId: number): Observable<OrganizationProfile> {
    return this.datasource.get(organizationId).pipe(map((dto) => this.mapper.toOrganizationProfile(dto)));
  }

  public update(organizationId: number, request: UpdateOrganizationProfile): Observable<OrganizationProfile> {
    return this.datasource.update(organizationId, this.mapper.toUpdateRequest(request)).pipe(
      map((dto) => this.mapper.toOrganizationProfile(dto)),
    );
  }

  public updateLogo(organizationId: number, file: File): Observable<OrganizationProfile> {
    return this.datasource.updateLogo(organizationId, file).pipe(
      map((dto) => this.mapper.toOrganizationProfile(dto)),
    );
  }
}
